import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import JsonLd from '@/components/base/JsonLd';
import { siteUrl, siteName, siteDescription, siteLogo } from '@/lib/seo';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import WhatSection from './components/WhatSection';
import ArticlesSection from './components/ArticlesSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import FinalCta from './components/FinalCta';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: siteName,
      description: siteDescription,
      inLanguage: ['en', 'pl', 'es', 'fr'],
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: siteName,
      url: `${siteUrl}/`,
      logo: {
        '@type': 'ImageObject',
        url: siteLogo,
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: siteName,
      description: siteDescription,
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'en',
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#categories') {
      const el = document.getElementById('categories');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatSection />
        <ArticlesSection />
        <ComparisonSection />
        <SafetySection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}